<div class="w-full mt-4 mb-4">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>
  <!--TITLE & DROPDOWN-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-xl font-medium mr-4">{{"CREDIT_TITLE"|translate}}</div>
    </div>
  </div>

  <div class="text-400 text-sm">{{"CREDIT_TEXT"|translate}}</div>
</div>
